import React from "react";
import { StyledImage } from "./style";

export const Image = ({
  setImgSrc,
  thumbnailSrc,
  originalSrc,
  maxwidth,
  width,
  height,
  direction,
}) => {
  return (
    <>
      <StyledImage
        src={thumbnailSrc}
        maxwidth={maxwidth ? maxwidth : "auto"}
        width={width ? width : "auto"}
        height={height ? height : "auto"}
        onClick={() =>
          setImgSrc({ src: originalSrc ?? thumbnailSrc, direction: direction })
        }
      ></StyledImage>
    </>
  );
};
